import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as TyreTakeoverOrderModels from '../../models/tyre-takeover-order/tyre-takeover-order';
import { TyreTakeoverOrderSearchModel } from '../../models/tyre-takeover-order/tyre-takeover-orderSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as Models from '../../models/commonModels';


@Injectable({
  providedIn: 'root'
})

export class TyreTakeoverOrderService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService) { }

  public getList(Search: TyreTakeoverOrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<TyreTakeoverOrderModels.TyreTakeoverOrderListModel>(`${this.environmentService.getApiURL()}/tyre-takeover-order/list`, Search, options);
 }

  public getStatusDictionary() {
    return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/tyre-takeover-order/status`);
  }

  public set(TyreTakeoverOrder: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreTakeoverOrderModels.TyreTakeoverOrderModel>>(`${this.environmentService.getApiURL()}/tyre-takeover-order/set`, TyreTakeoverOrder, options);
  }

  public get(TyreTakeoverOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreTakeoverOrderModels.TyreTakeoverOrderModel>>(`${this.environmentService.getApiURL()}/tyre-takeover-order/get`, TyreTakeoverOrder, options);
  }

  public create(TyreTakeoverOrder: Models.RequestNewOrder<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreTakeoverOrderModels.TyreTakeoverOrderModel>>(`${this.environmentService.getApiURL()}/tyre-takeover-order/create`, TyreTakeoverOrder, options);
  }

  public createBulk(TyreTakeoverOrder: Models.RequestNewOrder<TyreTakeoverOrderModels.TyreTakeoverOrderBulkModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreTakeoverOrderModels.TyreTakeoverOrderModel>>(`${this.environmentService.getApiURL()}/tyre-takeover-order/create-bulk`, TyreTakeoverOrder, options);
  }

  public setAuthorizationFile(TyreTakeoverOrder: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>, File: File) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "multipart/form-data")
      .set("Accept", "application/json");

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append("OrderId", TyreTakeoverOrder.Item.OrderId.toString());
    formData.append("RequestSignature", TyreTakeoverOrder.RequestSignature.toString());

    return this.httpClient.post<Models.Response<TyreTakeoverOrderModels.TyreTakeoverOrderModel>>(`${this.environmentService.getApiURL()}/tyre-takeover-order/set-authorization-file-document`, formData);
  }

  public getAuthorizationFile(TyreTakeoverOrder: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/tyre-takeover-order/get-authorization-file-document`, TyreTakeoverOrder, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public setProtocolFile(TyreTakeoverOrder: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>, File: File) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "multipart/form-data")
      .set("Accept", "application/json");

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append("OrderId", TyreTakeoverOrder.Item.OrderId.toString());
    formData.append("RequestSignature", TyreTakeoverOrder.RequestSignature.toString());

    return this.httpClient.post<Models.Response<TyreTakeoverOrderModels.TyreTakeoverOrderModel>>(`${this.environmentService.getApiURL()}/tyre-takeover-order/set-protocol-file-document`, formData);
  }

  public getProtocolFile(TyreTakeoverOrder: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/tyre-takeover-order/get-protocol-file-document`, TyreTakeoverOrder, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public deleteDeposite(TakeoverDepositesModel: Models.Request<TyreTakeoverOrderModels.TakeoverDepositesModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreTakeoverOrderModels.TakeoverDepositesModel>>(`${this.environmentService.getApiURL()}/tyre-takeover-order/delete-takeover-deposite`, TakeoverDepositesModel, options);
  }

  public addDeposite(TakeoverDepositesModel: Models.Request<TyreTakeoverOrderModels.TakeoverDepositesModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreTakeoverOrderModels.TakeoverDepositesModel>>(`${this.environmentService.getApiURL()}/tyre-takeover-order/add-takeover-deposite`, TakeoverDepositesModel, options);
  }

  public getHandoverProtocolPdf(TyreTakeoverOrder: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/tyre-takeover-order/handover-protocol-pdf`, TyreTakeoverOrder, options);
  }

  public getProtocolXls(TyreTakeoverOrder: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/tyre-takeover-order/protocol-xls`, TyreTakeoverOrder, options);
  }

  public importTyreFile(TyreTakeoverOrder: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>, File: File) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append("OrderId", TyreTakeoverOrder.Item.OrderId.toString());
    formData.append("RequestSignature", TyreTakeoverOrder.RequestSignature.toString());

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/tyre-takeover-order/import-tyre-file`, formData, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public importOrders(TyreTakeoverOrder: Models.RequestNewOrder<TyreTakeoverOrderModels.TyreTakeoverOrderModel>, File: File) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append("GarageId", TyreTakeoverOrder.Item.GarageId.toString());
    formData.append("AuthorizationText", TyreTakeoverOrder.Item.AuthorizationText);
    formData.append("Note", TyreTakeoverOrder.Note);
    formData.append("PlanExecuteDate", TyreTakeoverOrder.Item.PlanExecuteDate.toISOString());
    formData.append("TakeoverIsProtocolRequire", TyreTakeoverOrder.Item.TakeoverIsProtocolRequire.toString());
    formData.append("TakeoverSourceAddress", TyreTakeoverOrder.Item.TakeoverSourceAddress);    
    formData.append("RequestSignature", TyreTakeoverOrder.RequestSignature.toString());
    

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/tyre-takeover-order/import-orders`, formData, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }
}
